import { useEffect, useState } from "react";

import type { TExcelExportModule } from "./GridSynchronousDoNotUseDirectlyAsItHasHugeImpactOnBundleSize";

export const useLazyGridModuleExcelExport = () => {
    const [ExcelExportModule, setExcelExportModule] =
        useState<TExcelExportModule>();
    const [isExcelModuleLoading, setIsExcelModuleLoading] = useState(true);
    const [excelModuleError, setExcelModuleError] = useState<Error>();

    useEffect(() => {
        // Guard against overlapping/superseded loads (React Strict Mode's
        // double-invoked effect, or unmount): only the active run applies its
        // result, and a fresh attempt clears any previous error.
        let active = true;
        setIsExcelModuleLoading(true);
        setExcelModuleError(undefined);

        void import("@ag-grid-enterprise/excel-export")
            .then(module => {
                if (!active) {
                    return;
                }
                const { ExcelExportModule: loadedModule } = module as {
                    ExcelExportModule: TExcelExportModule;
                };
                setExcelExportModule(loadedModule);
            })
            .catch((error: unknown) => {
                if (!active) {
                    return;
                }
                setExcelModuleError(
                    error instanceof Error ? error : new Error(String(error)),
                );
            })
            .finally(() => {
                if (active) {
                    setIsExcelModuleLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, []);

    return {
        ExcelExportModule,
        isExcelModuleLoading,
        excelModuleError,
    };
};
